import { useSelector } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import Icon from 'fe-design-base/atoms/Icon';
import Text from 'fe-design-base/atoms/Text';
import Link from 'fe-design-base/molecules/Link';
import { Map as ImmutableMap } from 'immutable';

import { getCurrentCompanyPayrollPaymentAttemptsInfo } from 'selectors/session';

import { useHandleFailedPaymentModal } from 'features/payroll/hooks/useHandleFailedPaymentModal';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';

const { cx, cxEl } = cxHelpers('PayrollFailedPaymentBanner');

type PayrollPaymentAttemptsInfo = ImmutableMap<string, any>;

const PayrollFailedPaymentBanner = () => {
  const payrollPaymentAttemptsInfo: PayrollPaymentAttemptsInfo = useSelector(
    getCurrentCompanyPayrollPaymentAttemptsInfo
  );
  const { show_failed_payment_banner, button_text } =
    payrollPaymentAttemptsInfo?.toJS() || {};

  const handleOnClick = useHandleFailedPaymentModal();

  if (show_failed_payment_banner) {
    return (
      <Box className={cx()}>
        <Box
          row
          h={44}
          vcenter
          hcenter
          bgcolor="red100"
          className={cxEl('text')}
          gap={8}
        >
          <Icon iconName="Critical" size="medium" color="red300" />
          <Text
            color="mono900"
            i18n="payroll.failed_payment.dashboard.title"
            variant="bodySmBoldTight"
          />
          <Text
            color="mono900"
            i18n="payroll.failed_payment.dashboard.text"
            variant="bodySmTight"
          />
          <Link onClick={handleOnClick} size="small">
            {toI18n(`payroll.failed_payment.dashboard.cta.${button_text}`)}
          </Link>
        </Box>
      </Box>
    );
  }

  return null;
};

export default PayrollFailedPaymentBanner;
